/**
 * Cash counts (FSD Part 3, TRS-S09) — the register of counts across wallets.
 * The wiring packet spreads `TREASURY_WALLET_COUNTS_ROUTES` into the router
 * beside `TREASURY_ROUTES`.
 *
 * The literal `/treasury/wallet-counts` sits beside the existing count sheet
 * `/treasury/wallet-counts/:id(\d+)` (in `TREASURY_ROUTES`); the `\d+`
 * constraint keeps them apart. The nav alias that today maps this path to the
 * wallets list must be retargeted by the wiring packet.
 *
 * Gated on `treasury.wallet.read` — what `GET /wallet-counts` declares. The
 * sheet link on each row needs `treasury.wallet.count`, and the screen renders
 * the number as plain text without it.
 */

import type { RouteRecordRaw } from 'vue-router'

import { TREASURY_PERMISSIONS } from '@/modules/treasury/permissions'

export const TREASURY_WALLET_COUNTS_PATH = '/treasury/wallet-counts'

export const TREASURY_WALLET_COUNTS_ROUTES: RouteRecordRaw[] = [
  {
    path: TREASURY_WALLET_COUNTS_PATH,
    name: 'treasury-wallet-counts',
    component: () => import('@/modules/treasury/wallet-counts/WalletCountsView.vue'),
    meta: {
      titleKey: 'treasury.routeTitles.walletCounts',
      permission: TREASURY_PERMISSIONS.walletRead,
    },
  },
]
